/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getMADAA020, getPAJAC020CodeListPublic, getPAJAC020TaskManager } from '../../../services/Api';
import ResumePage from '../../../shared/components/ResumePage';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_CV } from '../../../shared/constants/app';
import {
    formatContactMethod,
    formatHomeUrl,
    ImageCheckFallback,
    parseResumeActiveInfo,
    parseResumeCareerInfo,
    parseResumeLicenseInfo,
    parseResumeSchoolInfo,
} from '../../../utils';

const MADAA020 = () => {
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [resumeSchoolInfo, setResumeSchoolInfo] = useState([]);
    const [resumeCareerInfo, setResumeCareerInfo] = useState([]);
    const [resumeLicenseInfo, setResumeLicenseInfo] = useState([]);
    const [resumeActiveInfo, setResumeActiveInfo] = useState([]);
    const codeLists = {
        A11: [],
        A14: [],
        A12: [],
    };
    const getListData = async () => {
        getPAJAC020TaskManager().then((res) => (codeLists.A11 = res.data));
        getPAJAC020CodeListPublic('A14,A12')
            .then(({ data }) => {
                codeLists.A14 = data?.A14;
                codeLists.A12 = data?.A12;
            })
            .catch((error) => console.log(error));
        await getMADAA020(id)
            .then(({ data }) => {
                setData({
                    ...data,
                    resumeClass: getCodeName(data?.resumeClass, 'A11'),
                    resumeLicense: getCodeName(data?.resumeLicense, 'A14'),
                    resumeForm: getCodeName(data?.resumeForm, 'A12'),
                    resumePosition: getResumePosition(data?.resumePosition),
                });
                if (data?.resumeSchoolInfo !== '') setResumeSchoolInfo(parseResumeSchoolInfo(data?.resumeSchoolInfo));
                if (data?.resumeCareerInfo !== '') setResumeCareerInfo(parseResumeCareerInfo(data?.resumeCareerInfo));
                if (data?.resumeLicenseInfo !== '')
                    setResumeLicenseInfo(parseResumeLicenseInfo(data?.resumeLicenseInfo));
                if (data?.resumeActiveInfo !== '') setResumeActiveInfo(parseResumeActiveInfo(data?.resumeActiveInfo));
            })
            .catch((error) => console.log(error));
    };
    useEffect(() => {
        if (id) {
            getListData();
        }
    }, [id]);

    // Hàm getCodeName
    const getCodeName = (codes, key) => {
        const list = codeLists[key]; // Lấy danh sách tương ứng với key
        const transformed = (codes || '')?.replace(/_/g, ', ')?.split(',');
        // Nếu không tìm thấy danh sách cho key, trả về mảng null
        if (!list) {
            return Array.isArray(transformed) ? transformed?.map(() => null) : [null];
        }
        // Đảm bảo codes là mảng, nếu không thì chuyển thành mảng
        const codeArray = Array.isArray(transformed) ? transformed : [transformed];

        // Loại bỏ khoảng trắng thừa ở đầu và cuối của từng mã
        const trimmedCodes = codeArray?.map((code) => code?.trim());
        const findCode = trimmedCodes.map((codeOrName) => {
            // Tìm theo code
            let found = list.find((item) => item.code === codeOrName);
            if (found) return found.code;
            // Tìm theo codeName
            found = list.find((item) => item.codeName === codeOrName);
            if (found) return found.code;
            // Không tìm thấy
            return '';
        });

        // Tìm codeName tương ứng cho từng mã đã được trim
        return findCode
            ?.sort((a, b) => Number(a) - Number(b))
            ?.map((code) => {
                const item = list?.find((item) => item?.code === code);
                return item
                    ? `${item?.codeName}${code === findCode[findCode.length - 1] ? '' : ','} `
                    : `${code}${code === findCode[findCode.length - 1] ? '' : ', '}`;
            });
    };
    const listResumePosition = [
        { codeName: '팀장', code: '001' },
        { codeName: '실장', code: '002' },
        { codeName: '스탭', code: '003' },
        { codeName: '무관', code: '999' },
    ];
    const getResumePosition = (value) => {
        const transformed = (value || '')?.replace(/_/g, ', ')?.split(',');
        // Nếu không tìm thấy danh sách cho key, trả về mảng null
        if (!listResumePosition) {
            return Array.isArray(transformed) ? transformed?.map(() => null) : [null];
        }
        // Đảm bảo codes là mảng, nếu không thì chuyển thành mảng
        const codeArray = Array.isArray(transformed) ? transformed : [transformed];

        // Loại bỏ khoảng trắng thừa ở đầu và cuối của từng mã
        const trimmedCodes = codeArray?.map((code) => code?.trim());
        const findCode = trimmedCodes.map((codeOrName) => {
            // Tìm theo code
            let found = listResumePosition.find((item) => item.code === codeOrName);
            if (found) return found.code;
            // Tìm theo codeName
            found = listResumePosition.find((item) => item.codeName === codeOrName);
            if (found) return found.code;
            // Không tìm thấy
            return '';
        });

        // Tìm codeName tương ứng cho từng mã đã được trim
        return findCode
            ?.sort((a, b) => Number(a) - Number(b))
            ?.map((code) => {
                const item = listResumePosition?.find((item) => item?.code === code);
                return item
                    ? `${item?.codeName}${code === findCode[findCode.length - 1] ? '' : ','} `
                    : `${code}${code === findCode[findCode.length - 1] ? '' : ', '}`;
            });
    };
    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_CV} />
                <div className="profile-content">
                    <div className="title-profile">이력서</div>
                    <div className="member-basic-infor MADAA020">
                        <div className="d-flex align-items-center mb-4 ">
                            <div
                                className="avatar-box"
                                style={{
                                    width: '142px',
                                    height: '172px',
                                    background: '#ddd',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <ImageCheckFallback
                                    folderName={'resume_logo'}
                                    imgName={data?.resumeLogo}
                                    alt="avtar"
                                    classImg={'rsm-dtl__img'}
                                />
                            </div>
                            <table className="table table-bordered member-infor">
                                <tbody>
                                    <tr>
                                        <th>이름</th>
                                        <td>{data?.nameKor}</td>
                                        <th>이메일</th>
                                        <td>{data?.email}</td>
                                    </tr>
                                    <tr>
                                        <th>전화번호</th>
                                        <td>{data?.telNo}</td>
                                        <th>핸드폰</th>
                                        <td>{data?.mobileNo}</td>
                                    </tr>
                                    <tr>
                                        <th>홈페이지</th>
                                        <td>
                                            {formatHomeUrl(data?.homeUrl) ? (
                                                <a
                                                    style={{ cursor: 'pointer' }}
                                                    href={formatHomeUrl(data?.homeUrl)}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {data?.homeUrl}
                                                </a>
                                            ) : (
                                                <span>{data?.homeUrl}</span>
                                            )}
                                        </td>
                                        <th>희망연락방법</th>
                                        <td>{formatContactMethod(data?.contactMethod)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* <div className="work-enviroment">
                        <div className="title-table">근무환경</div>
                        <div className="d-flex align-items-center gap-4">
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <th>희망업무</th>
                                        <td>{data?.resumeClass}</td>
                                    </tr>
                                    <tr>
                                        <th>소지자격증</th>
                                        <td>{data?.resumeLicense}</td>
                                    </tr>
                                    <tr>
                                        <th>희망 근무형태</th>
                                        <td>{data?.resumeForm}</td>
                                    </tr>
                                    <tr>
                                        <th>희망 근무지역</th>
                                        <td>
                                            {data?.resumeRegionSi1 &&
                                                data?.resumeRegionGu1 &&
                                                `1차 ${data.resumeRegionSi1} ${data.resumeRegionGu1}`}
                                            {data?.resumeRegionSi2 &&
                                                data?.resumeRegionGu2 &&
                                                ` / 2차 ${data.resumeRegionSi2} ${data.resumeRegionGu2}`}
                                            {data?.resumeRegionSi3 &&
                                                data?.resumeRegionGu3 &&
                                                ` / 3차 ${data.resumeRegionSi3} ${data.resumeRegionGu3}`}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>희망급여</th>
                                        <td>{data?.resumePay === '999' ? data?.resumePayEtc : data?.resumePay}</td>
                                    </tr>
                                    <tr>
                                        <th>희망직급</th>
                                        <td>{data?.resumePosition}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="education-history">
                        <div className="title-table">학력사항</div>
                        <div className="">
                            <table className="table highest-level">
                                <tbody>
                                    <tr>
                                        <th>최종학력</th>
                                        <td>고등학교 졸업</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="table list-education">
                                <thead>
                                    <tr>
                                        <th>재학기간</th>
                                        <th>구분</th>
                                        <th>학교명</th>
                                        <th>전공</th>
                                        <th>학점</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {resumeSchoolInfo && resumeSchoolInfo.length ? (
                                        resumeSchoolInfo.filter((item) => item?.from !== '.' && item?.to !== '.')
                                            .length ? (
                                            resumeSchoolInfo.map((item, index) => {
                                                if (item?.from === '.' || item?.to === '.') {
                                                    return null;
                                                }
                                                return (
                                                    item.from !== '.' && (
                                                        <tr key={'schoolInfo' + index}>
                                                            <td>
                                                                {item.from} ~ {item.to}
                                                            </td>
                                                            {index === 0 && (
                                                                <>
                                                                    <td>졸업</td>
                                                                    <td>{`${item.name}`}</td>
                                                                    <td>-</td>
                                                                    <td>-</td>
                                                                </>
                                                            )}
                                                            {index === 1 && (
                                                                <>
                                                                    <td>{item.status}</td>
                                                                    <td>{`${item.name} 대학 (${item.yearStudyDuration})`}</td>
                                                                    <td>{item.major}</td>
                                                                    <td>
                                                                        {item.gpa || '-'} / {item.gpaScale}
                                                                    </td>
                                                                </>
                                                            )}
                                                            {index === 2 && (
                                                                <>
                                                                    <td>{item.status}</td>
                                                                    <td>{`${item.name}`}</td>
                                                                    <td>{item.major}</td>
                                                                    <td>
                                                                        {item.gpa || '-'} / {item.gpaScale}
                                                                    </td>
                                                                </>
                                                            )}
                                                        </tr>
                                                    )
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan={5}>데이터 없습니다</td>
                                            </tr>
                                        )
                                    ) : (
                                        <tr>
                                            <td colSpan={5}>데이터 없습니다</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="experience-work">
                        <div className="title-table">경력사항</div>
                        <table className="table highest-level">
                            <tbody>
                                <tr>
                                    <th>경력사항</th>
                                    <td>
                                        {data?.resumeCareer === '009'
                                            ? `경력 (${data?.resumeCareerYear ? data?.resumeCareerYear : ''}년)`
                                            : '신입'}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        {data?.resumeCareer === '009' && (
                            <table className="table list-experience">
                                <thead>
                                    <tr>
                                        <th>근무기간</th>
                                        <th colSpan="2">상세경력</th>
                                    </tr>
                                </thead>
                                {resumeCareerInfo && resumeCareerInfo.length && resumeCareerInfo !== '' ? (
                                    resumeCareerInfo.filter((item) => item?.from !== '.' && item?.to !== '.').length ? (
                                        resumeCareerInfo.map((item, index) => {
                                            if (item?.from === '.' || item?.to === '.') {
                                                return null;
                                            }
                                            return (
                                                <tbody key={'careerInfo' + index}>
                                                    <tr>
                                                        <td rowSpan="4">
                                                            {item.from} ~ {item.to}
                                                        </td>
                                                        <th className="th"> 치과명</th>
                                                        <td style={{ textAlign: 'start' }}>{item.businessName}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className="th">근무지역/직책</th>
                                                        <td>
                                                            {item.location} / {item?.respon}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className="th">담당업무</th>
                                                        <td>{item.respon}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className="th">퇴사사유</th>
                                                        <td>
                                                            {item.reasonLeave &&
                                                                decodeHTMLEntities(decodeHTML(item?.reasonLeave))}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            );
                                        })
                                    ) : (
                                        <tbody>
                                            <tr>
                                                <td colSpan={3}>데이터 없습니다</td>
                                            </tr>
                                        </tbody>
                                    )
                                ) : (
                                    <tbody>
                                        <tr>
                                            <td colSpan={3}>데이터 없습니다</td>
                                        </tr>
                                    </tbody>
                                )}
                                <tbody>
                                    <tr>
                                        <th>기타 경력사항 및 기술서</th>
                                        <td colSpan="2" style={{ textAlign: 'start' }}>
                                            {data?.resumeCareerEtc}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        )}
                    </div>

                    <div className="licence-information">
                        <div className="title-table">자격/면허정보</div>
                        <div className="">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>구분</th>
                                        <th>자격증/면허증</th>
                                        <th>자격/면허번호</th>
                                        <th>발행처/발행기관</th>
                                        <th>취득일</th>
                                    </tr>
                                </thead>
                                {resumeLicenseInfo && resumeLicenseInfo.length ? (
                                    resumeLicenseInfo.filter((item) => item?.yearMonth !== '.').length ? (
                                        resumeLicenseInfo.map((item, index) => {
                                            if (item.yearMonth === '-.') {
                                                return (
                                                    <tbody key={`license-${index}`}>
                                                        <tr>
                                                            <td colSpan={2}>데이터 없습니다</td>
                                                        </tr>
                                                    </tbody>
                                                );
                                            }

                                            return (
                                                <tbody key={`license-${index}`}>
                                                    <tr>
                                                        <td>{item?.licenseType}</td>
                                                        <td>{item?.name}</td>
                                                        <td>{item?.licenseNumber}</td>
                                                        <td>{item?.agency}</td>
                                                        <td>{item?.yearMonth.split('-')[0]}</td>
                                                    </tr>
                                                </tbody>
                                            );
                                        })
                                    ) : (
                                        <tbody>
                                            <tr>
                                                <td colSpan={5}>데이터 없습니다</td>
                                            </tr>
                                        </tbody>
                                    )
                                ) : (
                                    <tbody>
                                        <tr>
                                            <td colSpan={5}>데이터 없습니다</td>
                                        </tr>
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </div>
                    <div className="licence-information2">
                        <div className="title-table">기타활동/사회경험</div>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>활동기간</th>
                                    <th colSpan={2}>상세활동</th>
                                </tr>
                            </thead>
                            {resumeActiveInfo && resumeActiveInfo.length ? (
                                resumeActiveInfo.filter(
                                    (item) => item?.yearMonthStart !== '.' && item?.yearMonthEnd !== '.',
                                ).length ? (
                                    resumeActiveInfo.map((item, index) => {
                                        if (item?.yearMonthStart === '.' || item?.yearMonthEnd === '.') {
                                            return null;
                                        }
                                        return (
                                            <tbody key={`active-${index}`}>
                                                <tr>
                                                    <td rowSpan={3}>
                                                        {item?.yearMonthStart} ~ {item?.yearMonthEnd}
                                                    </td>
                                                    <th>활동종류</th>
                                                    <td>{item?.type}</td>
                                                </tr>
                                                <tr>
                                                    <th>기관/장소</th>
                                                    <td>{item?.place}</td>
                                                </tr>
                                                <tr>
                                                    <th>활동내용</th>
                                                    <td>{decodeHTMLEntities(decodeHTML(item?.content))}</td>
                                                </tr>
                                            </tbody>
                                        );
                                    })
                                ) : (
                                    <tbody>
                                        <tr>
                                            <td colSpan={3}>데이터 없습니다</td>
                                        </tr>
                                    </tbody>
                                )
                            ) : (
                                <tbody>
                                    <tr>
                                        <td colSpan={3}>데이터 없습니다</td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </div>
                    <div className="self-introduction">
                        <div className="title-table">자기소개서</div>
                        <div
                            className="box-self-introduction"
                            dangerouslySetInnerHTML={{
                                __html: data?.resumeContent ? decodeHTML(data?.resumeContent) : '자기소새서 입력',
                            }}
                        ></div>
                    </div> */}
                    <ResumePage
                        data={data}
                        resumeSchoolInfo={resumeSchoolInfo}
                        resumeCareerInfo={resumeCareerInfo}
                        resumeLicenseInfo={resumeLicenseInfo}
                        resumeActiveInfo={resumeActiveInfo}
                    />
                    <div className="bottom-content" style={{ justifyContent: 'center' }}>
                        <Link to="/madaa010" className="button-back-to-list">
                            목록
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MADAA020;
